module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "reviewPage",
    attrs: {
      "id": "rew01"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagei"
    }
  }, [_c('h2', {
    staticClass: "reviewPageHead"
  }, [_vm._v("Praise for Penney Peirce’s")]), _vm._v(" "), _c('h2', {
    staticClass: "reviewPageHead1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(" frequency")])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“Penney Peirce has crafted a highly useful book that will help you reliably recognize the core vibration of your truest self and harness your sensitivity—so all areas of your life can change for the better.”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Carol Adrienne, PhD")]), _vm._v(", author of "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Purpose of Your Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“Penney Peirce, a master teacher, has gifted us with this powerful book that weaves so many strands in the consciousness tapestry into a coherent whole.”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Marcia Emery, PhD")]), _vm._v(", author of "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PowerHunch!")])]), _vm._v(" and "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Intuitive Healer")])])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“Frequency is an amazing ‘handbook for the future,’ synthesizing diverse views for expanding our perception and developing extraordinary human capacities.”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hal Zina Bennett")]), _vm._v(", author of "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Lens of Perception")])])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“From the title onward, Penney Peirce captures and explains the often misunderstood and overlooked subtleties of energy and vibration. As a psychic detective, I use body sensitivity and the ability to discern subtle energy for crime scene work, tuning in to the frequencies of a location to recreate what took place there. I’ve also taught children and families how to master their sensitivity to vibrations to ensure personal safety. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Frequency")]), _vm._v(" offers readers the tools to recognize and develop these sensitivities within themselves to speed personal growth and find greater freedom in life.”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Pam Coronado")]), _vm._v(", intuitive investigator and costar of "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Sensing Murder")])]), _vm._v(", Discovery Channel")])]), _c('a', {
    attrs: {
      "id": "pageii"
    }
  }, [_c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Frequency")]), _vm._v(" reveals the simplicity that underlies apparent chaos. In detailing and giving examples of how to get in touch with the soul’s purpose, action, and connection to others, Penney Peirce brings us the gift of how to live in alignment with the magnificence of who we truly are. This contribution rises as seminal in the transformation process for every person.”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Joan C. King, PhD")]), _vm._v(", neuroscientist, professor emerita, Tufts University School of Medicine and author of "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Cellular Wisdom")])])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“This book takes "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Secret")]), _vm._v(" to yet another level. At the center of it is an important truth. The left brain will argue with it, but if you listen to what Penney Peirce is saying with an ear attuned to what resonates in you, you will gain something lasting that really matters.”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Don Joseph Goewey")]), _vm._v(", author of "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Mystic Cool")])])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Frequency")]), _vm._v(" is filled with Penney’s profound wisdom and is deeply helpful to anyone wanting to raise their frequency, achieve inner/outer unity, and move toward emotional enlightenment.”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Margaret Paul, PhD")]), _vm._v(", author of "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Inner Bonding,")])]), _vm._v(" and coauthor of "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Do I Have to Give Up Me to Be Loved By You?")])]), _vm._v(" and "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Healing Your Aloneness")])])]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageText"
  }, [_vm._v("“A lot has been said about frequency and raising vibration in general, but this book is a well thought out and specific road map to the new realms of consciousness that we are all entering.”")]), _vm._v(" "), _c('p', {
    staticClass: "reviewPageSource"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hope and Randy Mead,")]), _vm._v(" creators of the movie "), _c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Orbs: The Veil is Lifting")])])])])]), _c('a', {
    attrs: {
      "id": "pageii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f0ff77b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781416546375_rew01.vue
// module id = 57
// module chunks = 0